import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./RecoverPinForm.module.scss";
import googleIcon from "assets/icons/google-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { createNewUser } from "service/AdminService";
import { postRegisterUser } from "store/slices/AdminSlice";
import Notification from "utils/Notifications";
import eye from 'assets/icons/eye.png'
import hidden from 'assets/icons/hidden.png'
import { getUserInfo, postRecoverPin, postRecoverPinCheckPin, postRecoverPasswordEndProgress } from "service/AuthService";
import { changePinCode, setUser } from "store/slices/UserSlice";
import tokenDecode from "utils/decode";

import { ScaleLoader } from "react-spinners";
import { Button } from "components";
import ModalWindow from "hooks/ModalWindow/ModalWindow";
import { getImage } from "service/BackgroundService";

import PinCode from "hooks/PinCode/PinCode";
import RecoverCode from "hooks/RecoverCode/RecoverCode";
import {
  checkPinCode,
} from "service/AuthService";
import {
  ChangePin,
  SendDevice,
  login,
} from "service/AuthService";
import { useNavigate } from "react-router-dom";


const RecoverPinForm = ({ setRecoverPin }) => {
  const { t } = useTranslation('common')
  const [loader, setLoader] = useState(false);
  const [pinWindow, setPinWindow] = useState(false);
  const [newPasswordWindow, setNewPasswordWindow] = useState(false);

  const [inn, setInn] = useState(null);
  const [password, setPassword] = useState(null);
  const [checkPassword, setCheckPassword] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [datainfo, setDataInfo] = useState(false);
  const [userPinCode, setUserPinCode] = useState();
  const [pinCode, setPinCode] = useState();
  const [recoverCode, setRecoverCode] = useState();
  const [userId, setUserId] = useState();
  const [device, setDevice] = useState("");

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setDevice(userAgent);
  }, []);
  let socket = null;

  const sendMessage = (message) => {
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(message);
    } else {
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const dispatch = useDispatch();
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(String(email).toLowerCase());
  };
  const pinLogIn = async () => {
    localStorage.setItem("mute", "false");

    // Wave Final (P0-9): client-side `pinCode === userPinCode` — критическая
    // уязвимость (PIN утекает через React DevTools / Redux state). Серверный
    // endpoint /api/employees/checkpin/ уже существует и реализует lockout +
    // выдаёт свежий JWT с pin_verified=true.
    if (String(pinCode).length !== 4) {
      setNotify({
        isOpen: true,
        message: t('auth.wrong_pin'),
        type: "error",
        sound: "error",
      });
      return;
    }
    setLoader(true);
    try {
      const verify = await checkPinCode(pinCode, userId || datainfo?.user);
      if (!verify?.data?.success) {
        setNotify({
          isOpen: true,
          message: t('auth.wrong_pin'),
          type: "error",
          sound: "error",
        });
        return;
      }
      if (verify.data.access) {
        localStorage.setItem('token', verify.data.access);
        if (verify.data.refresh) localStorage.setItem('refresh', verify.data.refresh);
      }
      setNotify({
        isOpen: true,
        message: t('auth.welcome'),
        type: "success",
      });

      const socket = new WebSocket("wss://sys.chu.kg/ws/online_status/");
      socket.onopen = () => {
        socket.send(JSON.stringify({ command: "connect", user_id: userId }));
        socket.close();
      };

      await SendDevice(device);
      setUserId(datainfo.user);
      sendMessage({ user_id: userId });
      dispatch(setUser(datainfo));
      setTimeout(() => {
        window.location.href = `/home/`;
      }, 1000);
    } catch (e) {
      // 401/423 — неверный PIN или lockout. Возвращаем дружелюбное сообщение
      // и не раскрываем серверную причину.
      setNotify({
        isOpen: true,
        message: e?.response?.status === 423
          ? t('auth.account_locked', 'Аккаунт временно заблокирован')
          : t('auth.wrong_pin'),
        type: "error",
        sound: "error",
      });
    } finally {
      setLoader(false);
    }
  };
  const createUserPin = async () => {

    if (String(pinCode)?.length < 4 || !pinCode) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_pin_short'),
        type: "error",
        sound: "error",
      });
    } else if (String(pinCode).length === 4) {
      try {
        setLoader(true);

        let response = await ChangePin(pinCode);
        dispatch(
          changePinCode({
            pin: pinCode,
          })
        );
        setTimeout(() => {
          setNotify({
            isOpen: true,
            message: t('auth.pin_set'),
            type: "success",
            sound: "success",
          });
        }, 1000);

        setNotify({
          isOpen: true,
          message: t('auth.welcome'),
          type: "success",
          sound: "success",
        });
        setTimeout(async () => {


       
          let response3 = await getImage(datainfo);
          if (datainfo?.them) {
            localStorage.setItem("background", "white");
          } else {
            localStorage.setItem("background", response3.data?.file);
          }
          let response2 = await SendDevice(device);

          setUserId(datainfo.user);
          sendMessage({ user_id: userId });
          dispatch(setUser(datainfo));
          setTimeout(() => {

            navigate(`/home/`);
          }, 2000);
        }, 1000);
      } catch (error) {
        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      }
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      inn === null
    ) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_inn'),
        type: "warning",
        sound: "warning",
      });
    }
    else if (inn.length < 5) {
      setNotify({
        isOpen: true,
        message: t('auth.inn_too_short'),
        type: "warning",
        sound: "warning",
      });
    } else if (password === "") {
      setNotify({
        isOpen: true,
        message: t('auth.enter_password'),
        type: "warning",
        sound: "warning",
      });
    } else {
      try {
        setLoader(true)
        
          let response = await login(inn, password);
          localStorage.setItem("token", response.data.access);
          const userId = tokenDecode(response.data.refresh);

          let userResponse = await getUserInfo(userId);
          const data = { ...userResponse.data, token: response.data.access };

          setUserPinCode(data.pin);
          setDataInfo(data)

     
        try {
          const recoverPin = "recover"
          let response = await postRecoverPin(
            recoverPin,
            inn
          );

          if (response?.data?.message) {
            if (response?.data?.status_log === 'ok') {
              setNotify({
                isOpen: true,
                message: response?.data?.message,
                type: "success",
                sound: "success",
              });
              setPinWindow(true)
              
            }
            else {
              setNotify({
                isOpen: true,
                message: response?.data?.message,
                type: "error",
                sound: "error",
              });
            }
          }
       
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
      } catch (error) {
        setNotify({
          isOpen: true,
          message:
            error.response.data.detail ||
            `${t('auth.password')} ${error.response.data.password}`,
          type: "error",
          sound: "error",
        });
      }finally {
        setLoader(false);
      }
    }
  };
  const handleSubmitCode = async (event) => {
    event.preventDefault();
    if (String(recoverCode)?.length < 6 || !recoverCode) {
      setNotify({
        isOpen: true,
        message: t('auth.enter_pin_short'),
        type: "error",
        sound: "error",
      });
    } else
      try {
        setLoader(true);
        
        const recoverPinCode = recoverCode
        let response = await postRecoverPinCheckPin(
          recoverPinCode,
          inn
        );

        if (response?.data?.message) {
          if (response?.data?.status_log === 'ok') {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "success",
              sound: "success",
            });
            setUserPinCode(null);
            setOpenModal(true);
          }
          else {
            setNotify({
              isOpen: true,
              message: response?.data?.message,
              type: "error",
              sound: "error",
            });
          }
        }


      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: "error",
          sound: "error",
        });
      } finally {
        setLoader(false);
      }
  };
 
  const forSelect = useSelector((state) => state.order.position);

  const dataRector = [forSelect];
  const handleInputChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^\d]/g, '');

    setInn(value);

  };
  const [isError, setIsError] = useState(false);


  return (
    <>
      <div className={`${styles.container} unv-form-card`}>

        <h2 className={`${styles.login__title} unv-form-card__title`}>{t('auth.recover_pin_title')}</h2>

        {pinWindow === false ? (
          newPasswordWindow === false ? (
            <>
              <h4 className={styles.login__untitle}>{t('auth.recover_pin_hint')}</h4>
              <form onSubmit={handleSubmit} noValidate>
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>
                    <label className={styles.datails} htmlFor="rp-inn">{t('auth.inn')}</label>
                    <input
                      id="rp-inn"
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      autoComplete="username"
                      placeholder={t('auth.inn')}
                      value={inn ?? ''}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className={styles.input_pox} style={{ width: '100%' }}>
                    <label className={styles.login__title__label} htmlFor="password">
                      {t('auth.password')}
                    </label>
                    <input
                      id="password"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={password ?? ''}
                      required
                      autoComplete="current-password"
                      onChange={(e) => setPassword(e.target.value)}
                      className={styles.login__input}
                    />

                    <button
                      type="button"
                      className={styles.show__password}
                      onClick={togglePasswordVisibility}
                      aria-label={showPassword ? t("auth.hide_password", "Скрыть пароль") : t("auth.show_password", "Показать пароль")}
                    >
                      {showPassword ? (
                        <img src={hidden} alt="" />
                      ) : (
                        <img src={eye} alt="" />
                      )}
                    </button>
                  </div>
                </div>

                {loader ? (
                  <ScaleLoader color="black" size={30} />
                ) : (
                  <div className={styles.button}>
                    <button
                      type="submit"
                      disabled={loader}
                    >
                      {t('auth.get_code')}
                    </button>
                  </div>
                )}
              </form>

              <h4 className={styles.login__untitle} style={{ marginTop: "10px" }}>{t('auth.support_phone_hint')} <b>0777404312</b>.</h4>
            </>
          ) : (
            <>
              <h4 className={styles.login__untitle}>{t('auth.pin_recovered_success')}</h4>
              <form action="#">
                <div className={styles.user_details}>
                  <div className={styles.input_pox} style={{ width: '100%' }}>

                    <input
                      style={{ backgroundColor: "#ebebeb" }}
                      type="text"
                      placeholder={t('auth.inn')}
                      value={inn}
                      readOnly={true}
                    />
                  </div>

                </div>


              </form>
            </>
          )
        ) : (

          <>
            <h4 className={styles.login__untitle}>{t('auth.enter_code_email')}</h4>
            <form onSubmit={handleSubmitCode} noValidate>
              <div className={styles.user_details}>
                <div className={styles.input_pox} style={{ width: '100%' }}>

                  <input
                    style={{ backgroundColor: "#ebebeb" }}
                    type="text"
                    placeholder={t('auth.inn')}
                    value={inn ?? ''}
                    readOnly
                    aria-label={t('auth.inn')}
                  />
                </div>
                <div style={{ width: '100%', paddingBottom: "20px" }}>
                  <RecoverCode setRecoverCode={setRecoverCode} passwordVisible={false} />
                </div>
              </div>

              {loader ? (
                <ScaleLoader color="black" size={30} />
              ) : (
                <div className={styles.button}>
                  <button
                    type="submit"
                    disabled={loader}
                  >
                    {t('auth.send_btn')}
                  </button>
                </div>
              )}
            </form>
          </>

        )}
        <hr className={styles.hr__line}></hr>

        <div className={styles.register_footer}>
          {t('auth.remember_pin')}

          <button
            type="button"
            className={styles.register_button}
            onClick={() => setRecoverPin(false)}
          >
            {t('auth.signin')}
          </button>


        </div>
      </div>

      <Notification notify={notify} setNotify={setNotify} />
      {userPinCode === null ? (
        <>
          <ModalWindow
            openModal={openModal}
            setOpenModal={setOpenModal}
            modalTitle={
              <>
                <p>
                  {t('auth.welcome')}
                </p>
              </>
            }
            modalText={t('auth.create_pin')}
            width={"unset"}
          >
            <PinCode setPinCode={setPinCode} passwordVisible={false} />

            {loader ? (
              <Button
                type="button"
                style={{ width: "unset", border: "none", background: "none" }}
              >
                <ScaleLoader color="black" size={15} />
              </Button>
            ) : (
              <>
                <Button
                  type="button"
                  onClick={() => setOpenModal(false)}
                  className={styles.btn_pin_close}
                >
                  {t('common.close')}
                </Button>
                <Button
                  type="button"
                  style={{ width: "unset" }}
                  onClick={createUserPin}
                  disabled={loader}
                  className={styles.btn_pin}
                >
                  {t('common.save')}
                </Button>
              </>
            )}
          </ModalWindow>{" "}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default RecoverPinForm;
